import {useEffect, useState} from "react";
import {GetSandboxStatus} from "../../api/Api";

// Whether this installation has a sandbox project, and where it is.
//
// Asked for by both the landing page and the dashboard, which is why the
// request is cached here rather than repeated per component - same reasoning
// as useHelpPortal: the answer is the same for everybody and changes about
// once in the life of an installation. The promise itself is the cache, so
// several components mounting at once share one request rather than racing.
//
// Never rejects - see GetSandboxStatus. "No sandbox configured" and "the
// lookup failed" are the same answer on purpose, because the caller does the
// same thing with both: hide the button.
let pending = null;

export const loadSandboxStatus = () => {
    if (!pending) pending = GetSandboxStatus();
    return pending;
};

// For tests, and for the rare case where a flag change should be picked up
// without a reload.
export const resetSandboxStatusCache = () => {
    pending = null;
};

export default function useSandboxStatus() {
    const [status, setStatus] = useState({available: false, publicId: null, name: null, loaded: false});

    useEffect(() => {
        let cancelled = false;

        loadSandboxStatus().then((result) => {
            if (cancelled) return;
            setStatus({...result, loaded: true});
        });

        return () => {cancelled = true};
    }, []);

    return status;
}
